import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import fieldId from 'constants/layout/fieldId'

export default class InputHidden extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.value !== this.props.value
  }

  handleChange = input => setTimeout(() => input.onChange(this.props.value), 50)

  renderField = field => {
    const { input } = field

    this.handleChange(input)

    return (
      <input
        {...input}
        type='hidden'
      />
    )
  }

  render() {
    const { name } = this.props

    return (
      <div className='form-group' id={`${fieldId}.${name}`}>
        <Field id={name} name={name} component={this.renderField} />
      </div>
    )
  }
}
